<template>
  <div
    class="flex flex-column custom-select white-bg relative left-align z5"
    :tabindex="tabindex"
    @blur="open = false"
  >
    <div
      class="selected col-12 p1 flex"
      :class="{ open: open }"
      @click="open = !open"
    >
      <span class="flex col-10 truncate">{{ isObject ? selected.label : selected }}</span>
      <span class="flex col-2 justify-end">
        <i
          class="h4 icon icon-angle-down-icon"
          :class="{ 'icon-angle-up-icon': open }"
        ></i>
      </span>
    </div>
    <div
      class="flex items white-bg mt1 border elevate"
      :class="{ selectHide: !open }"
    >
      <div class="col-12 flex flex-column py1">
        <div
          class="p1 col-12 flex item"
          v-for="(option, i) of options"
          :key="i"
          @click="selectedOption(option)"
        >
          <span class="flex">{{ isObject ? option.label : option }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, computed, onMounted } from "vue";
export default {
  props: {
    options: {
      type: Array,
      default: [],
    },
    default: {
      type: [String, Object],
      default: null,
    },
    tabindex: {
      type: Number,
      default: 0,
    },
  },
  setup(props, ctx) {
    const isObject = ref(props.default.hasOwnProperty('label'));
    const selected = ref(
      props.default
        ? props.default
        : props.options.length > 0
        ? props.options[0]
        : null
    );
    const open = ref(false);

    const selectedOption = (option) => {
      selected.value = option;
      open.value = false;
      ctx.emit("input", option);
    };

    onMounted(() => {
      ctx.emit("input", selected.value);
    });

    return {
      isObject,
      selected,
      open,
      selectedOption,
    };
  },
};
</script>

<style scoped>
.custom-select {
  outline: none;
  min-width: 200px;
}
.icon-angle-down-icon {
  line-height: 0.9;
}
.custom-select .selected {
  background-color: #fff;
  color: #222;
  cursor: pointer;
  user-select: none;
  border-radius: 3px;
  border: 1px solid #dadce0;
}

.custom-select .selected.open {
  color: #222;
  background-color: #bdc1c6;
}
.custom-select .items {
  color: #222;
  min-width: 200px;
  position: absolute;
  top: 48px;
  box-sizing: border-box;
  left: 0;
  right: 0;
}

.elevate {
  box-shadow: 0 10px 10px rgba(15, 31, 40, 0.5);
}
.custom-select .items div .item {
  color: #222;
  cursor: pointer;
  user-select: none;
}

.custom-select .items div .item:hover {
  background-color: #bdc1c6;
  color: #222;
}

.selectHide {
  display: none;
}
</style>
